import { render, staticRenderFns } from "./ApplicantEmergencyContact.vue?vue&type=template&id=1d6d80e9&scoped=true&"
import script from "./ApplicantEmergencyContact.vue?vue&type=script&lang=js&"
export * from "./ApplicantEmergencyContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6d80e9",
  null
  
)

export default component.exports